export const GOOGLE_TAG_MANAGER_NO_SCRIPT_SRC = 'https://www.googletagmanager.com/ns.html'
export const GOOGLE_TAG_MANAGER_SCRIPT_SRC = 'https://www.googletagmanager.com/gtm.js'
export const GOOGLE_TAG_MANAGER_SCRIPT_ID = 'google-tag-manager-script'
